import { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { twMerge } from "tailwind-merge";
import Editor from "components/Editor";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import { toastErrorSyle } from "hooks/utils/util";
import { usePostConsolePopup } from "hooks/console/usePostConsolePopup";
import { usePutConsolePopup } from "hooks/console/usePutConsolePopup";
import LoadingPop from "components/popup/LoadingPop";

const theadStyle = "text-[#222222] text-[16px] text-center";

export type PopupFormProps = {
    category: string;
    idx: string | null;
    vTitle: string;
    vPopSizeW: string;
    vPopSizeH: string;
    vPopX: string;
    vPopY: string;
    cViewYN: string;
    cTodayYN: string;
    cPvL: string;
    vContent: string;
};
export default function PopupForm({
    type,
    form,
    setForm,
    update,
}: {
    type: string;
    form: PopupFormProps;
    setForm: React.Dispatch<React.SetStateAction<PopupFormProps>>;
    update?: boolean;
}) {
    const navigate = useNavigate();
    const { mutate, isPending } = usePostConsolePopup();
    const { mutate: updatePopup, isPending: isPendingUpdate } = usePutConsolePopup();
    // console.log("notice data", data);
    // console.log("form", form);

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();

        const isFormEmpty =
            form.vPopSizeW.trim() === "" ||
            form.vPopSizeH.trim() === "" ||
            form.vPopX.trim() === "" ||
            form.vPopY.trim() === "" ||
            form.vTitle.trim() === "";

        if (isFormEmpty) {
            let message = "입력 필드를 모두 채워해주세요.";
            toast.error(message, toastErrorSyle);
            return;
        }

        if (update && form.idx) {
            const data = {
                ...form,
                category: type,
                idx: form.idx,
                vTitle: form.vTitle,
                vPopSizeW: Number(form.vPopSizeW),
                vPopSizeH: Number(form.vPopSizeH),
                vPopX: Number(form.vPopX),
                vPopY: Number(form.vPopY),
            };

            updatePopup(data, {
                onSuccess: data => {
                    // console.log(data.data.idx);
                    toast.success("성공적으로 수정 되었습니다.");
                },
                onError: (error: any) => {
                    const message = error.message;
                    toast.error(message, toastErrorSyle);
                },
            });
            return;
        }
        mutate(
            {
                ...form,
                category: type,
                vTitle: form.vTitle,
                vPopSizeW: Number(form.vPopSizeW),
                vPopSizeH: Number(form.vPopSizeH),
                vPopX: Number(form.vPopX),
                vPopY: Number(form.vPopY),
                // cViewYN: form.cViewYN,
                // cTodayYN: form.cTodayYN,
                // cPvL: form.cPvL,
                // vContent: form.vContent,
            },
            {
                onSuccess: data => {
                    toast.success("성공적으로 게시글 작성 되었습니다");
                    navigate(-1);
                },
                onError: (error: any) => {
                    const message = error.message;
                    toast.error(message, toastErrorSyle);
                },
            },
        );
    };

    return (
        <>
            {isPending || isPendingUpdate ? (
                <LoadingPop />
            ) : (
                <form onSubmit={onSubmit}>
                    <div className="mt-[8px] mb-[40px]">
                        <ConsoleHrozontalHeadTable
                            thead={[
                                {
                                    title: "제목",
                                    key: "vTitle",
                                    tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                    content: (row: string, tbodyData) => (
                                        <input
                                            type="text"
                                            id="vTitle"
                                            value={form.vTitle}
                                            onChange={e => {
                                                const value = e.target.value;

                                                setForm(prev => ({ ...prev, vTitle: value }));
                                            }}
                                            className="border rounded-[5px] px-2 py-1 w-full max-w-[50%]"
                                        />
                                    ),
                                },
                                {
                                    title: `팝업창사이즈\권장(300*400)`,
                                    key: "vPopSizeW",
                                    content: (row: string, tbodyData) => (
                                        <div className="flex w-full gap-5 max-w-[50%]">
                                            <div className="flex gap-x-2 flex-1 items-center">
                                                <label htmlFor="vPopSizeW" className="text-nowrap">
                                                    가로
                                                </label>
                                                <input
                                                    type="text"
                                                    id="vPopSizeW"
                                                    value={form.vPopSizeW}
                                                    onChange={e => {
                                                        const value = e.target.value;
                                                        const numericValue = value.replace(/[^0-9]/g, ""); // 숫자만 필터링

                                                        if (value !== numericValue) {
                                                            toast.error("숫자만 입력해주세요", toastErrorSyle);
                                                        } else {
                                                            setForm(prev => ({ ...prev, vPopSizeW: numericValue }));
                                                        }
                                                    }}
                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                />
                                            </div>
                                            <div className="flex gap-x-2 flex-1 items-center">
                                                <label htmlFor="vPopSizeH" className="text-nowrap">
                                                    세로
                                                </label>
                                                <input
                                                    type="text"
                                                    id="vPopSizeH"
                                                    value={form.vPopSizeH}
                                                    onChange={e => {
                                                        const value = e.target.value;
                                                        const numericValue = value.replace(/[^0-9]/g, ""); // 숫자만 필터링

                                                        if (value !== numericValue) {
                                                            toast.error("숫자만 입력해주세요", toastErrorSyle);
                                                        } else {
                                                            setForm(prev => ({ ...prev, vPopSizeH: numericValue }));
                                                        }
                                                    }}
                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                />
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    title: `팝업창위치지정\권장(550*250)`,
                                    key: "vPopX",
                                    thClassName: "w-[150px]",
                                    content: (row: string, tbodyData) => (
                                        <div className="flex w-full gap-5 max-w-[50%]">
                                            <div className="flex gap-x-2 flex-1 items-center">
                                                <label htmlFor="vPopX" className="text-nowrap">
                                                    가로
                                                </label>
                                                <input
                                                    type="text"
                                                    id="vPopX"
                                                    value={form.vPopX}
                                                    onChange={e => {
                                                        const value = e.target.value;
                                                        const numericValue = value.replace(/[^0-9]/g, ""); // 숫자만 필터링

                                                        if (value !== numericValue) {
                                                            toast.error("숫자만 입력해주세요", toastErrorSyle);
                                                        } else {
                                                            setForm(prev => ({ ...prev, vPopX: e.target.value }));
                                                        }
                                                    }}
                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                />
                                            </div>
                                            <div className="flex gap-x-2 flex-1 items-center">
                                                <label htmlFor="vPopY" className="text-nowrap">
                                                    세로
                                                </label>
                                                <input
                                                    type="text"
                                                    id="vPopY"
                                                    value={form.vPopY}
                                                    onChange={e => {
                                                        const value = e.target.value;
                                                        const numericValue = value.replace(/[^0-9]/g, ""); // 숫자만 필터링

                                                        if (value !== numericValue) {
                                                            toast.error("숫자만 입력해주세요", toastErrorSyle);
                                                        } else {
                                                            setForm(prev => ({ ...prev, vPopY: e.target.value }));
                                                        }
                                                    }}
                                                    className="border rounded-[5px] px-2 py-1 w-full"
                                                />
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    title: "팝업창사용여부",
                                    key: "cViewYN",
                                    tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                    content: (row: string, tbodyData) => (
                                        <div className="flex gap-5">
                                            <div className="flex gap-x-2 items-center">
                                                <input
                                                    type="radio"
                                                    name="cViewYN"
                                                    id="cViewY"
                                                    checked={form.cViewYN === "Y" ? true : false}
                                                    onChange={e => setForm(prev => ({ ...prev, cViewYN: e.target.checked ? "Y" : "N" }))}
                                                />
                                                <label htmlFor="cViewY" className="text-nowrap">
                                                    사용
                                                </label>
                                            </div>
                                            <div className="flex gap-x-2 items-center">
                                                <input
                                                    type="radio"
                                                    name="cViewYN"
                                                    id="cViewN"
                                                    checked={form.cViewYN === "N" ? true : false}
                                                    onChange={e => setForm(prev => ({ ...prev, cViewYN: e.target.checked ? "N" : "Y" }))}
                                                />
                                                <label htmlFor="cViewN" className="text-nowrap">
                                                    사용 안함
                                                </label>
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    title: "팝업 vs 레이어",
                                    key: "cPvL",
                                    tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                    content: (row: string, tbodyData) => (
                                        <div className="flex gap-5">
                                            <div className="flex gap-x-2 items-center">
                                                <input
                                                    type="radio"
                                                    name="cPvL"
                                                    id="P"
                                                    checked={form.cPvL === "P" ? true : false}
                                                    onChange={e => {
                                                        const checked = e.target.checked;
                                                        setForm(prev => ({ ...prev, cPvL: checked ? "P" : "L" }));

                                                        if (checked) {
                                                            alert("팝업으로 선택하실경우 팝업 차단 해제 설정이 필요할 수 있습니다.");
                                                        }
                                                    }}
                                                />
                                                <label htmlFor="P" className="text-nowrap">
                                                    팝업창
                                                </label>
                                            </div>
                                            <div className="flex gap-x-2 items-center">
                                                <input
                                                    type="radio"
                                                    name="cPvL"
                                                    id="L"
                                                    checked={form.cPvL === "L" ? true : false}
                                                    onChange={e => setForm(prev => ({ ...prev, cPvL: e.target.checked ? "L" : "P" }))}
                                                />
                                                <label htmlFor="L" className="text-nowrap">
                                                    레이어
                                                </label>
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    title: "팝업창1일유효여부",
                                    key: "cTodayYN",
                                    tdClassName: twMerge(theadStyle, "text-[#666666] text-left"),
                                    content: (row: string, tbodyData) => (
                                        <div className="flex gap-5">
                                            <div className="flex gap-x-2 items-center">
                                                <input
                                                    type="radio"
                                                    name="cTodayYN"
                                                    id="cTodayY"
                                                    checked={form.cTodayYN === "Y" ? true : false}
                                                    onChange={e => setForm(prev => ({ ...prev, cTodayYN: e.target.checked ? "Y" : "N" }))}
                                                />
                                                <label htmlFor="cTodayY" className="text-nowrap">
                                                    사용
                                                </label>
                                            </div>
                                            <div className="flex gap-x-2 items-center">
                                                <input
                                                    type="radio"
                                                    name="cTodayYN"
                                                    id="cTodayN"
                                                    checked={form.cTodayYN === "N" ? true : false}
                                                    onChange={e => setForm(prev => ({ ...prev, cTodayYN: e.target.checked ? "N" : "Y" }))}
                                                />
                                                <label htmlFor="cTodayN" className="text-nowrap">
                                                    사용 안함
                                                </label>
                                            </div>
                                        </div>
                                    ),
                                },

                                {
                                    title: "내용",
                                    key: "vContent",
                                    tdClassName: twMerge(theadStyle, "text-[#666666]"),
                                    content: (row: string) => (
                                        <div className="py-2" id="bounds">
                                            <Editor
                                                bounds="#bounds"
                                                value={form.vContent}
                                                onChangeHandler={(val: string) => setForm(prev => ({ ...prev, vContent: val }))}
                                                className="[&_.ql-editor]:min-h-[350px] h-auto responsive650:[&_.ql-editor]:min-h-[150px]"
                                            />
                                        </div>
                                    ),
                                },
                            ]}
                            tbody={form}
                        />

                        <div className="flex justify-center gap-2 mt-5">
                            <button className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]">
                                {update ? "수정" : "저장"}
                            </button>
                            <button
                                type="button"
                                className="text-[#666666] text-[18px] bg-white  rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                onClick={() => navigate(-1)}
                            >
                                {update ? "취소" : "목록"}
                            </button>
                        </div>
                    </div>
                </form>
            )}
            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
}
